import { render, staticRenderFns } from "./FeedVideoItem.vue?vue&type=template&id=3dc0718a&scoped=true&"
import script from "./FeedVideoItem.vue?vue&type=script&lang=js&"
export * from "./FeedVideoItem.vue?vue&type=script&lang=js&"
import style0 from "./FeedVideoItem.vue?vue&type=style&index=0&id=3dc0718a&scoped=true&lang=css&"
import style1 from "./FeedVideoItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc0718a",
  null
  
)

export default component.exports